import SEO from '@/components/base/SEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import LatestSection from './components/LatestSection';
import RankingSection from './components/RankingSection';
import { videos, featuredVideos, trendingVideos } from '@/mocks/videos';
import { videoCategories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';
import { Link } from 'react-router-dom';

export default function Home() {
  const heroVideo = videos[0];
  const movieVideos = videos.filter(v => v.category === 'dianying');
  const tvVideos = videos.filter(v => v.category === 'dianshiju');
  const animeVideos = videos.filter(v => v.category === 'dongman');
  const allVideos = videos;

  const homeSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '妖精视频',
    url: 'https://yaojingvideo.com',
    description: '妖精视频免费在线平台，聚合西瓜视频免费、91视频网站等高清资源，免费观看电视剧全集和最新电影，无需下载不缓冲，即点即播畅享观影。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://yaojingvideo.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <SEO
        title="妖精视频：免费在线观看西瓜视频免费与91视频网站高清电视剧全集不缓冲电影大全"
        description="妖精视频免费在线平台，聚合西瓜视频免费、91视频网站等高清资源，免费观看电视剧全集和最新电影，无需下载不缓冲，即点即播畅享观影。妖精视频免费、在线观看、西瓜视频免费、91视频网站、91在线视频、免费视频网站、高清电视剧、全集、不缓冲、电影大全、免费播放。"
        keywords="妖精视频免费,在线观看,西瓜视频免费,91视频网站,91在线视频,免费视频网站,高清电视剧,全集,不缓冲,电影大全,免费播放"
        canonicalUrl="https://yaojingvideo.com/"
        schema={homeSchema}
      />

      <Navbar />

      <main>
        <HeroSection featuredVideo={heroVideo} categories={videoCategories} />

        <FeaturedSection featuredVideos={featuredVideos} />

        <LatestSection
          videos={tvVideos}
          categoryName="电视剧"
          categorySlug="dianshiju"
          title="热播电视剧"
        />

        <RankingSection videos={allVideos} />

        <LatestSection
          videos={movieVideos}
          categoryName="电影"
          categorySlug="dianying"
          title="最新电影"
        />

        <section className="py-10 md:py-14">
          <div className="container-site">
            <div className="flex items-center justify-between mb-6">
              <div>
                <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
                  热门动漫
                </h2>
                <p className="text-sm text-foreground-500 mt-1">高分动漫作品推荐</p>
              </div>
              <Link
                to="/category/dongman"
                className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-400 transition-colors whitespace-nowrap"
              >
                查看全部
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {animeVideos.slice(0, 4).map(video => (
                <Link
                  key={video.id}
                  to={`/article/${video.id}`}
                  className="group block cursor-pointer"
                >
                  <div className="relative overflow-hidden rounded-lg mb-3 aspect-video">
                    <img
                      src={video.thumbnail}
                      alt={video.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 rounded text-xs text-foreground-200 whitespace-nowrap">
                      {video.duration}
                    </div>
                    <div className="absolute top-2 left-2 px-2 py-0.5 bg-primary-500/90 rounded text-xs text-background-50 dark:text-foreground-950 font-medium whitespace-nowrap">
                      {video.quality}
                    </div>
                    <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <div className="w-12 h-12 flex items-center justify-center bg-primary-500 rounded-full shadow-lg">
                        <i className="ri-play-fill text-background-50 dark:text-foreground-950 text-xl"></i>
                      </div>
                    </div>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                    {video.title}
                  </h3>
                  <div className="flex items-center gap-2 mt-1.5 text-xs text-foreground-500 flex-wrap">
                    <span className="flex items-center gap-1">
                      <i className="ri-star-fill text-accent-500 text-xs"></i>
                      {video.rating}
                    </span>
                    <span>{video.views.toLocaleString()}次</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-100/50">
          <div className="container-site">
            <div className="flex items-center justify-between mb-6">
              <div>
                <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
                  最新资讯
                </h2>
                <p className="text-sm text-foreground-500 mt-1">影视动态与观影指南</p>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {articles.slice(0, 3).map(article => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group bg-background-50 rounded-lg overflow-hidden border border-background-300/30 hover:border-primary-500/30 transition-all cursor-pointer"
                >
                  <div className="aspect-[16/9] overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-4">
                    <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-500 line-clamp-2 mb-3">{article.excerpt}</p>
                    <div className="flex items-center justify-between text-xs text-foreground-500">
                      <span>{article.date}</span>
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line"></i>
                        {article.views.toLocaleString()}
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14">
          <div className="container-site">
            <div className="bg-gradient-to-r from-primary-500/20 via-accent-500/10 to-primary-500/20 rounded-2xl p-8 md:p-12 text-center border border-primary-500/10">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
                开始你的观影之旅
              </h2>
              <p className="text-sm md:text-base text-foreground-500 mb-6 max-w-lg mx-auto">
                海量高清视频资源，电视剧全集、最新电影、热门综艺应有尽有。无需下载，即点即播，畅享流畅观影体验。
              </p>
              <div className="flex items-center justify-center gap-3 flex-wrap">
                <Link
                  to="/category/dianying"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-film-line"></i>
                  浏览电影
                </Link>
                <Link
                  to="/category/dianshiju"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-background-200 hover:bg-background-300 text-foreground-800 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-tv-line"></i>
                  观看电视剧
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}